import { render, staticRenderFns } from "./check_item_detail.vue?vue&type=template&id=0b7edc5e"
import script from "./check_item_detail.vue?vue&type=script&lang=js"
export * from "./check_item_detail.vue?vue&type=script&lang=js"
import style0 from "./check_item_detail.vue?vue&type=style&index=0&id=0b7edc5e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports